import React from 'react';
import ReactDOM from 'react-dom/client';
import { Buffer } from 'buffer';
import App from './App';
import './index.css';

// Polyfill Buffer for browser (needed by base64url package)
window.Buffer = Buffer;

// Set dark theme globally
const style = document.createElement('style');
style.textContent = ':root { color-scheme: dark; }';
document.head.appendChild(style);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
